import { Back4app2 } from '@back4app2/sdk';
import { API_HTTP_URL, API_WS_URL } from './settings';
import { useEffect, useState } from 'react';

type ConnCb = (isConnected: boolean, isReconnecting: boolean) => void;

const g = globalThis as any;

// keep callbacks stable across HMR reloads
const onConnectionStatusChangeCallbacks: ConnCb[] =
  g.__b4a2OnConnCallbacks ?? (g.__b4a2OnConnCallbacks = []);

const back4app2: Back4app2 =
  g.__b4a2DashboardSdk ??
  (g.__b4a2DashboardSdk = new Back4app2({
    httpUrl: API_HTTP_URL,
    wsUrl: API_WS_URL,
    onConnectionStatusChange: (isConnected, isReconnecting) => {
      onConnectionStatusChangeCallbacks.forEach((cb) =>
        cb(isConnected, isReconnecting)
      );
    },
}));

export default back4app2;

export const useBack4app2ConnectionStatus = (): { isConnected: boolean, isReconnecting: boolean } => {
  const [status, setStatus] = useState<{ isConnected: boolean, isReconnecting: boolean }>({
    isConnected: back4app2.isConnected,
    isReconnecting: back4app2.isReconnecting
  });

  useEffect(() => {
    const cb: ConnCb = (isConnected, isReconnecting) => setStatus({ isConnected, isReconnecting });
    onConnectionStatusChangeCallbacks.push(cb);

    return () => {
      const idx = onConnectionStatusChangeCallbacks.indexOf(cb);
      if (idx >= 0) onConnectionStatusChangeCallbacks.splice(idx, 1);
    };
  }, []);

  return status;
};
